export default __webpack_public_path__ + "static/media/g.0d64390a.png";